const specialOffer = () => {

    var modalMask = document.getElementById('modalMask');

    document.addEventListener('DOMContentLoaded', function () {
        var specialBtn = document.getElementsByClassName('specialOffer-btn');
        var specialEdt = document.getElementsByClassName('special-edit');
        var specialRmv = document.getElementsByClassName('special-remove');

        for (var i = 0; i < specialBtn.length; i++) {
            var btn = specialBtn[i] as HTMLElement;

            if (!btn.classList.contains('btn-specialNot')) {
                btn.onclick = function (event) {
                    openModal('specialOffer-modal', event.target);
                }
            }
            
        }
        for (var j = 0; j < specialEdt.length; j++) {
            var edt = specialEdt[j] as HTMLElement;
            edt.onclick = function (event) {
                openModal('specialOffer-modal', event.target);
            }
        }
        for (var k = 0; k < specialRmv.length; k++) {
            var rmv = specialRmv[k] as HTMLElement;
            rmv.onclick = function (event) {
                openModal('remove-modal', event.target);
            }
        }

        var close = document.getElementsByClassName('close-link');

        for (var i = 0; i < close.length; i++) {
            var cls = close[i] as HTMLElement;
            cls.onclick = function () {
                closeAllModals();
            }
        }        

        var submitCancel = document.getElementsByClassName('cancelSpecialInput')[0] as HTMLElement;

        submitCancel.onclick = function () {
            closeModal('specialOffer-modal');
        }

        var removeCancel = document.getElementsByClassName('cancelSpecialRemove')[0] as HTMLElement;

        removeCancel.onclick = function () {
            closeModal('remove-modal');
        }

        var editModes = document.getElementsByClassName('special-timer');
        for (var c = 0; c < editModes.length; c++) {
            if (editModes[c].classList.contains('notValid')) {
                editModes[c].parentElement.classList.remove('special-hover');
            }
        }      

    });

    function setModalItem(btn) {
        var itemTitle = btn.closest('tr').getElementsByClassName('ui-price-title')[0] as HTMLElement;
        document.getElementsByClassName('specialModal-item')[0].getElementsByTagName("p")[0].innerHTML = itemTitle.innerHTML;
    }
    function setModalImg(btn) {
        var item = btn.closest('tr').getElementsByClassName('ui-price-image')[0] as HTMLImageElement;
        document.getElementsByClassName('specialModal-item')[0].getElementsByTagName("img")[0].src = item.src;
    }
    

    function openModal(modalID , btn) {
        var modal = document.getElementById(modalID);
        modal.style.display = "block";
        modalMask.style.display = "block";
        modalMask.onclick = function () {
            closeAllModals();
        }

        if (modalID == 'remove-modal') {
            var offerId = btn.parentElement.parentElement;
            var rmvHdn = document.getElementById('hdnOfferId') as HTMLInputElement;
            rmvHdn.value = offerId.dataset.offerid;
        }


        if (modalID == 'specialOffer-modal') {
            setModalItem(btn);
            setModalImg(btn);
            var hdn = btn.closest('tr').getElementsByTagName('td')[0].getElementsByTagName('input')[0] as HTMLInputElement;
            var newHdn = document.getElementById('hdnPriceID') as HTMLInputElement;
            newHdn.value = hdn.value;


            var remainHours = document.getElementById('txtOfferHoure') as HTMLInputElement;
            var remianTimeSelect = document.getElementById('rdpTimeSelect') as HTMLInputElement;
            var remianTimeDefault = document.getElementById('rdbTimeDiscount') as HTMLInputElement;
            var stickCheck = document.getElementById('chkStickyOffer') as HTMLInputElement;
            var submitBtn = document.getElementById('ibtnSubmitSpecialInput') as HTMLLinkElement;
            var timeInput = document.getElementById('txtOfferHoure') as HTMLInputElement;
            var href = submitBtn.href;
            var startCheck = document.getElementById('chkStartTimeSelect') as HTMLInputElement;
            var startDay = document.getElementById('txtStartDay') as HTMLInputElement;
            var startHour = document.getElementById('txtStartHour') as HTMLInputElement;
            var startMinute = document.getElementById('txtStartMinute') as HTMLInputElement;

            if (btn.classList.contains('btn')) {
                remianTimeSelect.checked = false;
                remianTimeDefault.checked = false;
                stickCheck.checked = false;
                startCheck.checked = false;
                timeInput.value = "";
                startDay.value = "";
                startHour.value = "";
                startMinute.value = "";
            }

            if (!btn.classList.contains('btn')) {
                submitBtn.classList.remove('btn-specialNot');
                submitBtn.href = href;

                if (btn.dataset.sticky == 'true') {
                    stickCheck.checked = true;
                } else {
                    stickCheck.checked = false;
                }

                if (btn.dataset.hour) {
                    remianTimeSelect.checked = true;
                    remainHours.value = btn.dataset.hour;

                } else {
                    remianTimeDefault.checked = true;
                    remainHours.value = "";
                }
                if (btn.dataset.startdate) {
                    startCheck.checked = true;
                    var time = btn.dataset.startdate;
                    time = parseInt(time);
                    var date = new Date(time);
                    var day = date.toLocaleDateString('fa-IR');
                    var hour = date.getHours();
                    var minute = date.getMinutes();
                    startDay.value = day;
                    startHour.value = hour.toString();
                    startMinute.value = minute.toString();
                } else {
                    startCheck.checked = false;
                    startDay.value = "";
                    startHour.value = "";
                    startMinute.value = "";
                }
            }

            if (!startCheck.checked) {
                startDay.disabled = true;
                startHour.disabled = true;
                startMinute.disabled = true;
                startDay.parentElement.classList.add('input-disabled');
            }

            if (!remianTimeSelect.checked) {
                timeInput.disabled = true;
                timeInput.parentElement.classList.add('input-disabled');
            }

            submitBtn.classList.add('btn-specialNot');
            submitBtn.href = '';

            remianTimeSelect.onchange = function () {
                submitBtn.classList.remove('btn-specialNot');
                submitBtn.href = href;
                if (remianTimeDefault.checked) {
                    timeInput.disabled = true;
                    timeInput.parentElement.classList.add('input-disabled');
                } else {
                    timeInput.disabled = false;
                    timeInput.parentElement.classList.remove('input-disabled');

                }
            };

            startCheck.onchange = function () {
                if (startCheck.checked) {
                    startDay.disabled = false;
                    startHour.disabled = false;
                    startMinute.disabled = false;
                    startDay.parentElement.classList.remove('input-disabled');
                } else {
                    startDay.disabled = true;
                    startHour.disabled = true;
                    startMinute.disabled = true;
                    startDay.parentElement.classList.add('input-disabled');
                }
            }

            remianTimeDefault.onchange = function () {
                submitBtn.classList.remove('btn-specialNot');
                submitBtn.href = href;
                if (remianTimeDefault.checked) {
                    timeInput.disabled = true;
                    timeInput.parentElement.classList.add('input-disabled');
                } else {
                    timeInput.disabled = false;
                    timeInput.parentElement.classList.remove('input-disabled');
                }
            };



            if (!btn.classList.contains('btn')) {
                submitBtn.classList.remove('btn-specialNot');
                submitBtn.href = href;
                
                if (btn.dataset.sticky == 'true') {
                    stickCheck.checked = true;
                } else {
                    stickCheck.checked = false;
                }

                if (btn.dataset.hour) {
                    remianTimeSelect.checked = true;
                    remainHours.value = btn.dataset.hour;

                } else {
                    remianTimeDefault.checked = true;
                    remainHours.value = "";
                }
            }

        }
    }

    function closeModal(modalID) {
        var modal = document.getElementById(modalID);
        modal.style.display = "none";
        modalMask.style.display = "none";
    }

    function closeAllModals() {
        closeModal('specialOffer-modal');
        closeModal('remove-modal');
    }


};

export {
    specialOffer
};